<div class="row md-pad-right-20">
  <div class="column twelve pad-bottom-10"></div>
  <div class="column twelve pad-bottom-20 md-pad-left-20">
    <div class="none md-block policy-summary-header">
      <div class="column five">
        <p class="policy-header-title"><span>Policy Number</span></p>
      </div>
      <div class="column">
        @if (type !== 'life' && !isPolicyCancelled) {
          <p class="policy-header-title">Policy Term</p>
        }
        @if (type === 'life' || (type !== 'life' && isPolicyCancelled)) {
          <p class="policy-header-title">
            Effective Date
            @if (isPolicyCancelled) {
              <span class="status-pill margin-left-4"> Updated </span>
            }
          </p>
        }
      </div>
    </div>
    <div class="policy-summary-items">
      @for (policy of policies; track policy; let isLastPolicy = $last) {
        <div class="column twelve">
          <div
            class="policy column twelve"
            [class.last-policy]="isLastPolicy"
            [ngClass]="{ 'pad-top-4': policy.isPolicyCancelled }"
          >
            <div class="policy-basics column twelve md-five">
              <div class="column twelve md-none sm-five policy-summary-header">
                <p class="policy-header-title">Policy Number</p>
              </div>
              <div class="column twelve md-twelve sm-seven pad-top-20 sm-pad-top-0">
                <ng-container>
                  @if (type === 'auto') {
                    <p class="policy-number-auto">{{ policy | prettyPolicyNum }}</p>
                  } @else {
                    <p class="policy-number">
                      <a [routerLink]="[url, policy.policyNumber]">
                        Policy {{ policy | prettyPolicyNum }}
                      </a>
                    </p>
                  }
                </ng-container>
                @if (policy.policyRisks) {
                  <ul class="policy-risk">
                    @for (risk of policy.policyRisks; track risk; let isLastRisk = $last) {
                      <li>
                        @if (policy.policyType === 'auto') {
                          <a
                            [dsRouterLink]="[url, policy.policyNumber]"
                            [queryParams]="{ vehicleId: risk.vehicleId }"
                            data-cy="vehicleLink"
                          >
                            {{ risk | risk }}
                          </a>
                        }
                        @if (policy.policyType !== 'life' && policy.policyType !== 'auto') {
                          <span>
                            {{ risk | risk }}
                            @if (!isLastRisk) {
                              ,
                            }
                          </span>
                        }
                        <!-- <span *ngIf="policy.policyType !== 'life' && (isPartner$ | async)">
                        {{ risk | risk }}
                        <ng-template [ngIf]="!isLastRisk">,</ng-template>
                      </span> -->
                        @if (policy.policyType === 'life') {
                          <span>
                            {{ (policy?.policyRisks)[0] | titleCase }}
                          </span>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
            <div class="policy-effective-date column twelve md-seven">
              <div class="policy-basics column twelve md-seven">
                <div
                  class="column twelve md-none sm-five policy-summary-header pad-top-20 md-pad-top-0"
                >
                  @if (type !== 'life' && !policy.isPolicyCancelled) {
                    <p class="policy-header-title">Policy Term</p>
                  }
                  @if (type === 'life' || (type !== 'life' && policy.isPolicyCancelled)) {
                    <p class="policy-header-title">
                      Effective Date
                      @if (policy.isPolicyCancelled) {
                        <span class="status-pill margin-left-4"> Updated </span>
                      }
                    </p>
                  }
                </div>
                <div
                  class="column twelve md-twelve sm-seven pad-top-20 md-pad-top-0 font-size-0-85 policy-period"
                  [ngClass]="policy.isPolicyCancelled ? 'pad-top-30' : 'pad-top-20'"
                >
                  @if (type !== 'life') {
                    <p>
                      {{ policy.periodStartDate | date: 'shortDate' }} -
                      @if (policy.isPolicyCancelled) {
                        <span>{{ policy.cancelDate | date: 'shortDate' }}</span>
                      } @else {
                        {{ policy.periodEndDate | date: 'shortDate' }}
                      }
                    </p>
                  }
                  @if (type === 'life') {
                    <p>{{ policy.periodStartDate | date: 'shortDate' }}</p>
                  }
                </div>
              </div>
              <div class="column twelve md-five pad-top-20 md-pad-top-0">
                @if (policy.policyType !== 'auto') {
                  <button
                    ds-button
                    type="button"
                    [dsRouterLink]="[url, policy.policyNumber]"
                    class="-outline-white md-float-right"
                    data-cy="policySummaryViewDetails"
                  >
                    View Details
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (type === 'auto') {
        <div
          class="button-text column twelve pad-top-20 border-top"
          data-cy="policySummaryAutoButtons"
        >
          <ng-container *dsPartnerAFI>
            <a
              authCheck
              [permissionName]="'replacevehicle_veiwaddvehicle'"
              [checkAction]="'disable'"
              (click)="replaceVehicle()"
              data-cy="policiesOverviewReplaceVehicleButton"
              >Add or Replace Vehicle</a
            >
          </ng-container>
          @if (
            (partnerAddVehicleEnabled$ | async) &&
            (isPartner$ | async) &&
            (activeAutoPolicies$ | async)?.length > 0
          ) {
            <span>
              <a (click)="routeToAddVehicle()">Add Vehicle</a>
            </span>
          }
          @if ((showChangeMyCoverageButton$ | async) && (changeCoverageEnabled$ | async)) {
            <span class="pad-left-30"></span>
          }
          @if ((showChangeMyCoverageButton$ | async) && (changeCoverageEnabled$ | async)) {
            <span class="pad-left-10"
              ><a (click)="coverageChange()">Edit Coverage Amounts</a>
            </span>
          }
        </div>
      }
    </div>
  </div>
</div>
<ds-grace-period
  [gracePeriodDays]="gracePeriodDays$ | async"
  [(visible)]="displayPolicyGracePeriod"
  [activeAgents]="activeAgents$ | async"
  [user]="userState$ | async"
></ds-grace-period>
